export default __webpack_public_path__ + "static/150-a81d8358e2a27497e2d14ccae6ecdde6.gif";